import { useCallback, useRef } from 'react';

export function useSubmitGuard() {
    const isSubmittingRef = useRef(false);

    const guardedSubmit = useCallback((submitFn) => {
        if (isSubmittingRef.current) {
            return false;
        }
        isSubmittingRef.current = true;
        submitFn();
        return true;
    }, []);

    const releaseSubmitGuard = useCallback(() => {
        isSubmittingRef.current = false;
    }, []);

    return { guardedSubmit, releaseSubmitGuard };
}
